import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DataGridTable } from '@/ui'
import styles from './ContractDetails.module.scss'

export const DetailsOfPartiesInformation = ({ contract, subTitleAction }) => {
	const {
		t,
		i18n: { language },
	} = useTranslation()

	const languageFields = {
		rus: 'companyName',
		kz: 'companyNameKaz',
	}

	const detailsOfEmployer = useMemo(
		() => [
			{ title: t('bin_iin'), data: contract?.bin },
			{ title: t('name'), data: contract?.[languageFields[language]] },
		],
		[contract, t]
	)

	const detailsOfPartiesEmployee = useMemo(
		() => [
			{ title: t('yin'), data: contract?.iin },
			{ title: t('fio'), data: contract?.fullName },
		],
		[contract, t]
	)

	const detailsOfRepresentative = useMemo(
		() => [
			{ title: t('iin'), data: contract?.representativeIin },
			{ title: t('fio'), data: contract?.representativeName },
		],
		[contract, t]
	)

	return (
		<div className={styles.container}>
			<DataGridTable
				title={t('parties_requisites')}
				titleClass={styles.tableTitleCell}
				subTitle={t('employer')}
				subTitleClass={styles.subTitle}
				information={detailsOfEmployer}
			/>
			<DataGridTable
				hideTitle
				titleClass={styles.tableTitleCell}
				subTitle={t('employee')}
				subTitleClass={styles.subTitle}
				information={detailsOfPartiesEmployee}
				subTitleAction={subTitleAction}
			/>
			{contract?.representativeIin ? (
				<DataGridTable
					hideTitle
					titleClass={styles.tableTitleCell}
					subTitle={t('representative')}
					subTitleClass={styles.subTitle}
					information={detailsOfRepresentative}
				/>
			) : null}
		</div>
	)
}
